import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { InventoryBalancesImportModel } from 'src/app/models/imports/inventory-balances-import.model';
import { InventoryModel } from 'src/app/models/inventory/inventory.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InventoryService {

  constructor(private _httpClient: HttpClient) { }

  createInventory(inventoryContractModel: InventoryModel): Observable<InventoryModel> {
    return this._httpClient.post<InventoryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventory.CreateInventory}`,
      inventoryContractModel);
  }

  deleteInventory(inventoryId: number): Observable<InventoryModel> {
    return this._httpClient.delete<InventoryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventory.DeleteInventory}/${inventoryId}`);
  }

  downloadGuideImport(): Observable<HttpEvent<Blob>> {
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryBalance.DownloadGuideImport}`,
      null, { reportProgress: true, responseType: 'blob' }));
  }

  exportConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventory.ExportConsultation}`, filters, {
      params, responseType: 'blob',
    });
  }

  exportImportErrors(alerts: PreInvoicingAlertModel[]): Observable<Blob> {
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryBalance.ExportImportErrors}`, alerts,
      {
        responseType: 'blob'
      }
    );
  }

  getAllInventoriesForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventory.GetAllInventoriesForSelectAsync}`,);
  }

  getAllInventoriesForSelectWithOutSubrentalAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventory.GetAllInventoriesForSelectWithOutSubrentalAsync}`,);
  }

  getAllInventoriesForSelectReportAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventory.GetAllInventoriesForSelectReportAsync}`,);
  }

  getAllTypeInventoriesForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventory.GetAllTypeInventoriesForSelectAsync}`,);
  }

  getAllInventoryClassForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventory.GetAllInventoryClassForSelectAsync}`,);
  }

  getAllInventoriesWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventory.GetAllInventoriesWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getAllInventoryWithSubrental(): Observable<Array<InventoryModel>> {
    return this._httpClient.get<Array<InventoryModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventory.GetAllInventoryWithSubrental}`);
  }

  getAllInventory(): Observable<Array<InventoryModel>> {
    return this._httpClient.get<Array<InventoryModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventory.GetAllInventory}`);
  }

  getFirstInventoryByCompanyAuthenticatedAsync(): Observable<InventoryModel> {
    return this._httpClient.get<InventoryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventory.GetFirstInventoryByCompanyAuthenticatedAsync}`);
  }

  getFirstInventoryByCompanyId(companyId: number): Observable<InventoryModel> {
    return this._httpClient.get<InventoryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventory.GetFirstInventoryByCompanyId}/${companyId}`);
  }

  getInventoryByCode(code: number): Observable<InventoryModel> {
    return this._httpClient.get<InventoryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventory.GetInventoryByCode}/${code}`)
  }

  getInventoryById(inventoryId: number): Observable<InventoryModel> {
    return this._httpClient.get<InventoryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventory.GetInventoryById}/${inventoryId}`);
  }

  getColumnsConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventory.GetColumnsConsultationAsync}`);
  }

  getInventorySubrental(): Observable<InventoryModel> {
    return this._httpClient.get<InventoryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventory.GetInventorySubrental}`);
  }

  importInventoryBalances(rowsImports: InventoryBalancesImportModel[]): Observable<LoadPreInvoicingModel> {
    return this._httpClient.post<LoadPreInvoicingModel>(
      `${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryBalance.ImportInventoryBalancesAsync}`, rowsImports
    );
  }

  reverseImportBalances(branchId: number): Observable<boolean> {
    return this._httpClient.delete<boolean>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventoryBalance.ReverseImportBalances}/${branchId}`);
  }

  updateInventory(inventoryContractModel: InventoryModel): Observable<InventoryModel> {
    return this._httpClient.put<InventoryModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.inventory.UpdateInventory}`,
      inventoryContractModel);
  }
}
